// extracted by mini-css-extract-plugin
export default {"inner":"e5U0j1dp"};